var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap_404" }, [
    _c(
      "div",
      [
        _c("img", { attrs: { src: require("./404.png"), alt: "404" } }),
        _vm._v(" "),
        _c("p", [_vm._v("页面丢失！")]),
        _vm._v(" "),
        _vm.goBack
          ? _c("div", { staticClass: "btn", on: { click: _vm.gogo } }, [
              _vm._v(_vm._s(_vm.goBackTxt) + " "),
              _c("i", { staticClass: "el-icon-right" })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63325fb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63325fb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/404/index.vue
// module id = null
// module chunks = 